import { useCallback, useEffect, useRef, useState } from 'react'
import { getOrdinanceData } from '../services/personService'
import useNotifications from './useNotifications'

export default function usePersonOrdinances(personId) {
  const { showServerNotifications, warn } = useNotifications()
  const [ordinanceData, setOrdinanceData] = useState()
  const [refetchSwitch, setRefetchSwitch] = useState(true)
  const isMounted = useRef(true)

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    const fetchOrdinanceData = async () => {
      try {
        const response = await getOrdinanceData(personId)
        if (isMounted.current && response?.status === 200) {
          setOrdinanceData(response.data)
        }
      } catch (err) {
        if (isMounted.current) {
          showServerNotifications(err?.response?.data?.notifications, 'error')
        }
      }
    }
    if (personId) {
      fetchOrdinanceData()
    }
  }, [personId, refetchSwitch, showServerNotifications, warn])

  const refetchOrdinances = useCallback(() => setRefetchSwitch(!refetchSwitch), [refetchSwitch])

  return {
    ordinanceData,
    refetchOrdinances,
    setOrdinanceData,
  }
}
